  
import { morph } from '@theme/morph';

  window.addEventListener(
    'message',
    async (e) => {
      if (!e.data || !e.data.event) return;

      switch (e.data.event) {
        case 'byoLoaded': {
          const iframe = document.querySelector('#string-byo-embed');
          // @ts-ignore
          if (iframe && iframe.contentWindow) {
            // @ts-ignore
            iframe.contentWindow.postMessage({ event: 'enableCart', data: {} }, '*');
          }
          break;
        }

        case 'cartUpdate': {
          const items = e.data?.data?.items || [];
          // @ts-ignore
          const itemsToAdd = [];

          // @ts-ignore
          items.forEach((item) => {
            // @ts-ignore
            const variantId = window.barcodeMap[item.ean] || window.barcodeMap[+item.ean];
            if (variantId) {
              itemsToAdd.push({
                id: Number(variantId),
                quantity: item.quantity,
              });
            }
          });

          if (itemsToAdd.length > 0) {
            try {
              // 1. Gather all section elements needing an HTML update
              const cartComponents = document.querySelectorAll('cart-items-component, cart-drawer-component, header-actions-component');
              const sectionIds = new Set();

              cartComponents.forEach((comp) => {
                // @ts-ignore
                const sectionId = comp.dataset.sectionId || comp.closest('.shopify-section')?.id?.replace('shopify-section-', '');
                if (sectionId) sectionIds.add(sectionId);
              });

              // 2. Prepare payload requesting updated section HTML from Shopify
              const payload = {
                // @ts-ignore
                items: itemsToAdd,
                sections: Array.from(sectionIds).join(','),
              };

              // @ts-ignore
              const addUrl = Theme?.routes?.cart_add_url || '/cart/add.js';

              const response = await fetch(addUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify(payload),
              });

              const responseData = await response.json();

              if (responseData.sections) {
                // 3. Swap in the updated HTML sections returned by the server
                Object.entries(responseData.sections).forEach(([sectionId, htmlString]) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(htmlString, 'text/html');
                  const newSection = doc.querySelector(`.shopify-section, #${sectionId}, [data-section-id="${sectionId}"]`);
                  const currentSection = document.getElementById(`shopify-section-${sectionId}`) || document.querySelector(`[data-section-id="${sectionId}"]`);

                  if (currentSection && newSection) {
                    // Use theme morphing if available, otherwise replace HTML directly
                    // @ts-ignore
                    if (morph) {
                      // @ts-ignore
                      morph(currentSection, newSection);
                    } else {
                      currentSection.innerHTML = newSection.innerHTML;
                    }
                  }
                });
              }

              // 4. Force active cart drawers or web components to fetch updated state
              const cartItemsComponent = document.querySelector('cart-items-component');
              // @ts-ignore
              if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
                // @ts-ignore
                await cartItemsComponent.fetchCartData();
              }

              // 5. Open the cart drawer automatically (if applicable)
              const cartDrawer = document.querySelector('cart-drawer-component, #CartDrawer');
              console.warn({cartDrawer})
              if (cartDrawer) {
                // @ts-ignore
                if (typeof cartDrawer.open === 'function') {
                  // @ts-ignore
                  cartDrawer.open();
                } else {
                  cartDrawer.setAttribute('active', 'true');
                  cartDrawer.classList.remove('is-empty');
                }
              }

              // 6. Global event dispatches for secondary theme listeners
              document.dispatchEvent(new CustomEvent('theme-drawer:open', { bubbles: true, detail: responseData }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: responseData }));

            } catch (err) {
              console.error('Error adding products to cart:', err);
            }
          }
          break;
        }
      }
    },
    true
  );